import type {SelectedRun} from '@wandb/forge-shell-contract/aria';

/**
 * runKey is a run chip's identity.
 *
 * NOTE: Run names are unique only within a project, so the entity/project scope
 * is part of the key — otherwise same-named runs from different projects would
 * collide on add/remove and duplicate as tags.
 */
export function runKey(run: SelectedRun): string {
  return `${run.entityName}/${run.projectName}/${run.name}`;
}
